import Layout from './layout'
export default [
  // 品库编辑
  {
    path: '/kzManage',
    component: Layout,
    meta: { groupTitle: '品库后台', roles: ['admin'] },
    children: [
      {
        path: '',
        name: 'kzManage',
        component: () => import(/* webpackChunkName: "kzManage" */ '@v/kzManage'),
        meta: { title: '快站管理', icon: 'kz_manage' },
      }],
  },
]
